
    // THIS IS AN AUTO-GENERATED FILE, IT IS UPDATED WITH GULP PUBLISH'S --tag [VALUE]
    // DO NOT EDIT THIS FILE, YOUR CHANGES WILL BE LOST

    export const VERSION = {
      "number": '2.2.1 (Build 9)'
    };
